import React, { useEffect, useState } from 'react';
import './Companies.scss';
import Helmet from 'react-helmet';
import PageWrapper from '../../components/ui/layout/PageWrapper';
import Pagination from '../../components/ui/pagination/Pagination';
import Search from '../../components/search/Search';
import counterpart from 'counterpart';
import Table from '../../components/ui/table/Table';
import Text from '../../components/ui/text/Text';
import { connect } from 'react-redux';
import { AppState } from '../..';
import Button from '../../components/ui/button/Button';
import { setCompaniesField, fetchCompanies, fetchCompanyTrialBalance } from '../../actions/companiesActions';
import { ICompaniesReducerState } from '../../reducers/companiesReducer';
import { ICompany, TrialStatus } from '../../models/Company';
import { Link } from 'react-router-dom';
import Modal from '../../components/modal/Modal';
import ErrorNotification from '../../components/ui/error-notification/ErrorNotification';
import ExtendTrial from '../../components/companies/extend-trial/ExtendTrial';
import { GeTrialBalanceResponse } from '../../utils/grpc/generated/Billsby.Protos/revenues/private/company/company_pb';
import ProgressIndicator from '../../components/ui/progress-indicator/ProgressIndicator';

interface ICompanies {
  companies: ICompaniesReducerState;
  dispatch: Function;
}

const Companies: React.FC<ICompanies> = ({ companies, dispatch }) => {
  const [output, setOutput] = useState(<div />);
  const [selectedCompanyName, setSelectedCompanyName] = useState('');
  const [selectedCompanyId, setSelectedCompanyId] = useState<number | undefined>(undefined);
  const [showExtendTrialModal, setShowExtendTrialModal] = useState(false);
  const [hasError, setHasError] = useState(false);
  const { searchedCompanies, companiesPaginated, hasCompanies, isLoading } = companies;

  useEffect(() => {
    dispatch(fetchCompanies(1));
  }, []);

  const renderSearchBar = () => {
    return (
      <div className="companies__search">
        <Search
          value={searchedCompanies}
          placeholder="COMPANIES_SEARCH_PLACHOLDER"
          onChange={(evt: any) => dispatch(setCompaniesField('searchedCompanies', evt.target.value))}
          onSearch={() => dispatch(fetchCompanies(1, undefined, searchedCompanies))}
        />
        <Pagination
          className="companies__search__pagination"
          pageCount={companiesPaginated.pageCount}
          isVisible={companiesPaginated.pageCount > 1}
          onPageChange={({ selected }) => {
            dispatch(fetchCompanies(selected + 1, undefined, searchedCompanies));
          }}
        />
      </div>
    );
  };

  const renderTrialStatus = (data: ICompany) => {
    switch (data.status) {
      case TrialStatus.Live:
        return <Text content="COMPANIES_TRIAL_LIVE" component="td" translateWith={{ link: <Link className="companies__table__link" to="/">Billsby</Link> }} noMargin />
      case TrialStatus.GettingStarted1:
      case TrialStatus.GettingStarted2:
        return <Text content="COMPANIES_TRIAL_GETTING_STARTED1" component="td" noMargin />
      case TrialStatus.PreLive:
        return <Text content="COMPANIES_PRELIVE" component="td" noMargin />
      case TrialStatus.OnTrial:
        return <Text content="COMPANIES_TRIAL_ON_TRIAL" component="td" noMargin />
      default:
        return null
    }
  }

  const renderCompaniesTable = () => {
    return (
      <Table className="companies__table">
        <thead>
          <tr>
            <Text content="COMPANIES_TABLE_NAME" component="th" noMargin />
            <Text content="COMPANIES_TABLE_DOMAIN_NAME" component="th" noMargin />
            <Text content="COMPANIES_TABLE_ID" component="th" noMargin />
            <Text content="COMPANIES_TABLE_INDUSTRY" component="th" noMargin />
            <Text content="COMPANIES_TABLE_TRIAL_STATUS" component="th" noMargin />
            <th />
          </tr>
        </thead>
        <tbody>
          {companiesPaginated.results && companiesPaginated.results.map((data, idx) => (
            <tr key={idx}>
              <Text content={data.name} component="td" noMargin shouldTranslate={false} />
              <Text content={`${data.companyDomain}`} component="td" noMargin shouldTranslate={false} />
              <Text content={`${data.companyId}`} component="td" noMargin shouldTranslate={false} />
              <Text content={data.industry} component="td" noMargin shouldTranslate={false} />
              {renderTrialStatus(data)}
              <td className="companies__table__actions">
                {/* {data.status === TrialStatus.OnTrial &&
                  <Button
                    id="access-account"
                    buttonType="add"
                    title="COMPANIES_BUTTON_EXTEND_TRIAL"
                    isFullWidth
                    onClick={() => {
                      setSelectedCompanyName(data.name);
                      setSelectedCompanyId(data.companyId);
                      setShowExtendTrialModal(true);
                    }}>
                  </Button>} */}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  };

  if (!companiesPaginated.results) {
    return <ProgressIndicator color="blue" coverage='full-content' />
  }
  
  return (
    <div className="companies">
      <Helmet title={counterpart('COMPANIES_TITLE')} />

      <PageWrapper>
        {renderSearchBar()}
        {isLoading
            ? <ProgressIndicator color="blue" coverage='full-content' />
            : renderCompaniesTable()}
      </PageWrapper>

      <Modal
        isOpen={showExtendTrialModal}
        onRequestClose={() => {
          setSelectedCompanyName('');
          setSelectedCompanyId(undefined);
          setShowExtendTrialModal(false);
        }}
        title="EXTEND_TRIAL_MODAL_TITLE"
        translateWith={{ companyName: selectedCompanyName }}>
        <ExtendTrial
          companyId={selectedCompanyId}
          callBack={() => {
            dispatch(fetchCompanies(companies.companiesPaginated.currentPage, undefined, companies.searchedCompanies));
            setShowExtendTrialModal(false);
          }}
        />

      </Modal>
      <ErrorNotification
        title="ERROR_OCCURED"
        showAlert={hasError}
        showButton={false}
        showSubtitle={false}
        onClose={() => setHasError(false)} />
    </div>
  );
};

export default connect((state: AppState) => ({ companies: state.companies }))(Companies);
